<template>
  <div class="pages-index">
    <div class="carousel-banner">
      <swiper :options="swiperOptionBanner">
        
        <swiper-slide class="item2">
          <img class="banner-img" :src="require('@/assets/images/index-banner2-1.jpg')" />
          <div class="details-box">
            <img :src="require('@/assets/images/index-banner2-2.png')" />
            <router-link to="/main/routeDev"><el-button size="medium" class="btn" type="success">查看详情</el-button></router-link>
          </div>
        </swiper-slide>

                <swiper-slide class="item4">
          <img class="banner-img" :src="require('@/assets/images/index-banner4-1.jpg')" />
          <div class="details-box">
            <img :src="require('@/assets/images/index-banner4-2.png')" />
            <router-link to="/main/SDWAN"><el-button size="medium" class="btn" type="warning">查看详情</el-button></router-link>
          </div>
        </swiper-slide>

                 <swiper-slide class="item1">
          <img class="banner-img" :src="require('@/assets/images/index-banner1-2.jpg')" />
          <div class="details-box" data-wow-duration="1.2s" data-wow-delay="0.1s">
            <!-- <img :src="require('@/assets/images/index-banner1-2.png')" /> -->
            <router-link  to="/main/fusionGateway2"><el-button class="btn" style="" type="primary">查看详情</el-button></router-link>
          </div>
        </swiper-slide>

                <swiper-slide class="item3">
          <img class="banner-img" :src="require('@/assets/images/index-banner3-1.jpg')" />
          <div class="details-box wow zoomIn">
            <img :src="require('@/assets/images/index-banner3-2.png')" />
            <router-link to="/main/smartTV"><el-button size="medium" class="btn" type="info">查看详情</el-button></router-link>
          </div>
        </swiper-slide>


        <swiper-slide class="item1">
          <img class="banner-img" :src="require('@/assets/images/index-banner1-1-tp.jpg')" />
          <div class="details-box" data-wow-duration="1.2s" data-wow-delay="0.1s">
            
            <router-link  to="/main/smartScreen"><el-button class="btn" style="" type="primary">查看详情</el-button></router-link>
          </div>
        </swiper-slide>
        

        <!-- slides -->
        <swiper-slide class="item1">
          <router-link to="/downloadaccel">
          <img class="banner-img" :src="require('@/assets/images/binzhu2.jpg')" />
          </router-link>
          <div class="details-box" data-wow-duration="1.2s" data-wow-delay="0.1s">
            <!-- <img :src="require('@/assets/images/index-banner1-2.png')" /> -->
            <!-- <router-link  to="/main/download"><el-button class="btn"  style="margin-top: 560px;margin-right: 880px;" type="primary">立即下载</el-button></router-link> -->
          </div>
        </swiper-slide>







        
       
        <div class="swiper-pagination swiper-banner-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev swiper-banner-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next swiper-banner-button-next" slot="button-next"></div>
      </swiper>     
    </div>
    <!-- <div class="bgbox-gray">
      <el-col class="card-show" :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <swiper :options="swiperOptionCard">
         
          <swiper-slide>
            <a href="https://w.url.cn/s/A0Rz4Kv" target="_blank">
              <div class="item wow slideInUp" data-wow-delay="0s">
                <h3>SD-WAN组网解决方案</h3>
                <h4>SD-WAN NETWORKING SOLUTION</h4>
                <div class="img-box">
                  <img :src="require('@/assets/images/index-plan1.png')" />
                </div>
                <p>深度解码：5G物联网时代，神行者X-WAN强大优势背后的掘金之道</p>
                <el-button round>MORE<i class="el-icon-d-arrow-right"></i></el-button>
              </div>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="https://w.url.cn/s/AlTYsP9" target="_blank">
              <div class="item wow slideInUp" data-wow-delay="0.2s">
                <h3>智慧酒店解决方案</h3>
                <h4>SMART HOTEL SOLUTION</h4>
                <div class="img-box">
                  <img :src="require('@/assets/images/index-plan2.png')" />
                </div>
                <p>阿里、腾讯入局酒店，未来酒店智慧化是趋势吗？</p>
                <el-button round>MORE<i class="el-icon-d-arrow-right"></i></el-button>
              </div>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="https://w.url.cn/s/A5Pc0aY" target="_blank">
              <div class="item wow slideInUp" data-wow-delay="0.3s">
                <h3>神行者智慧桌面解决方案</h3>
                <h4>XSPEEDER SMART DESKTOP SOLUTION</h4>
                <div class="img-box">
                  <img :src="require('@/assets/images/index-plan3.png')" />
                </div>
                <p>神行者皮肤商城C系列全新上线，丰富配色任你选择！</p>
                <el-button round>MORE<i class="el-icon-d-arrow-right"></i></el-button>
              </div>
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="https://w.url.cn/s/APiIIKl" target="_blank">
              <div class="item wow slideInUp" data-wow-delay="0.1s">
                <h3>高校联合运营解决方案</h3>
                <h4>UNIVERSITY OPERATION SOLUTION</h4>
                <div class="img-box">
                  <img :src="require('@/assets/images/index-plan4.png')" />
                </div>
                <p>神行者丨高校多运营&联合运营解决方案</p>
                <el-button round>MORE<i class="el-icon-d-arrow-right"></i></el-button>
              </div>
            </a>
          </swiper-slide>
         
          <div class="swiper-pagination swiper-card-pagination" slot="pagination"></div>
          <div class="swiper-button-prev swiper-card-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next swiper-card-button-next" slot="button-next"></div>
        </swiper>
      </el-col>
    </div> -->
    <div class="bgbox-white">
      <div class="module-title fc-blue">
        神行者产品
      </div>
      <div class="product-box" style="padding-top:50px;box-sizing:border-box;">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:8}">
              <div class="item-img wow slideInLeft">
                <img :src="require('@/assets/images/index-product1.png')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:16}">
              <router-link to="/main/SDWAN">
                <div class="conts wow slideInRight">
                  <div class="title">
                    <h3>神行者SD-WAN组网业务</h3>
                    <h4>SD-WAN NETWORKING SERVICE</h4>
                  </div>
                  <p class="article">神行者SD-WAN以网络即服务(NaaS)和安全即服务(SaaS)的 方式，为<span class="fc-blue">多分支机构、数据中心互联、混合云</span>等场景的用户提供广域安全组网方案。</p>
                  <p class="article">同时针对广域网及内网数据日益严重的安全风险，解决网络运维成本高、广域组网复杂等网络问题，提供<span class="fc-blue">“端-网-云”</span>一体的内生安全防护能力。让<span class="fc-blue">网络更安全，让安全更智能</span>。</p>
                </div>
              </router-link>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-gray">
      <div class="product-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <router-link to="/main/routeDev">
                <div class="conts wow slideInLeft">
                  <div class="title">
                    <h3>神行者路由流控</h3>
                    <h4>ROUTING FLOW CONTROL</h4>
                  </div>
                  <p class="article">神行者路由是一款基于 SDN 构架而实现的流量控制管理系统，系统架构主要由应用特征库、应用识别系统、应用管理系统、应用路由四大部分组成，并通过系统管理、网络管理、策略管理、监控统计、面板管理五大人机互动管理功能对流经的所有网络数据进行实时监控与管理。</p>
                  <div class="stress-box">
                    <h5>核心优势</h5>
                    <div class="stress-items">
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.5s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress1-1.png')" />
                        <p>协议分流</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.6s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress1-2.png')" />
                        <p>链路负载</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.7s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress1-3.png')" />
                        <p>AI 防封杀</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.8s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress1-4.png')" />
                        <p>日志分析</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.9s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress1-5.png')" />
                        <p>DNS 管控</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="1s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress1-6.png')" />
                        <p>实时热备</p>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="item-img wow slideInRight">
                <img :src="require('@/assets/images/index-product2.png')" />
              </div>  
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-white">
      <div class="product-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="item-img wow slideInLeft">
                <img :src="require('@/assets/images/index-product3.png')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <router-link to="/main/smartTV">
                <div class="conts wow slideInRight">
                  <div class="title">
                    <h3>神行者IPTV智能桌面</h3>
                    <h4>IPTV SMART DESKTOP</h4>
                  </div>
                  <p class="article">IPTV 服务器采集视频数据高效可靠，通过资源口实时缓冲一定时间内数据，同时 支持添加硬盘保存数据。支持可自定义界面，控制 apk信息展示。终端 APP 基于安 卓系统开发，兼容主流智能电视，机顶盒，接入网络简单，自动实现与后端 IPTV 服务器通信。</p>
                  <div class="stress-box">
                    <h5>核心优势</h5>
                    <div class="stress-items">
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.5s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress2-1.png')" />
                        <p>云平台管理</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.6s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress2-2.png')" />
                        <p>三层投屏</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.7s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress2-3.png')" />
                        <p>界面定制</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.8s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress2-4.png')" />
                        <p>功能定制</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="0.9s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress2-5.png')" />
                        <p>服务定制</p>
                      </div>
                      <div class="item wow bounceInDown" data-wow-duration="1.5s" data-wow-delay="1s">
                        <img style="width: 35px;height: 35px;" :src="require('@/assets/images/index-stress2-6.png')" />
                        <p>增值服务</p>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-gray">
      <div class="product-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <router-link to="/main/logAudit">
                <div class="conts wow slideInLeft">
                  <div class="title">
                    <h3>神行者日志审计</h3>
                    <h4>LOG AUDIT</h4>
                  </div>
                  <p class="article">神行者日志（XspeederLog）是基于公司多年经验推出的基于大数据架构的新一代日志审计系统，针对客户部署的神行者路由流控设备实现日志数据的高效采集、统一管理、集中存储、统计分析。如针对排名、分布、趋势和相似性分析，提供 IP 轨迹、TOP 域名、应用流量流向图、URL 地图、TOP 用户、连接可视化分析和 DNS 可视化分析等为代表的分析工具，并可协助运营商高效统一管理网络日志并为安全事件的事后取证提供依据。</p>
                  <p class="article">系统基于 SOA 架构设计，采用 B/S 管理模式。<span class="fc-blue">系统由日志采集、日志处理、日志管理、事件监测、日志存储、统计分析、告警响应以及系统管理</span>八个子系统构成。各子系统相互耦合、协作，保证整个系统稳定、高效。</p>
                </div>
              </router-link>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="item-img wow slideInRight">
                <img :src="require('@/assets/images/index-product4.png')" />
              </div>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-white">
      <div class="module-title fc-blue">
        SD-WAN项目案例
      </div>
      <div class="project-box project-sdwan wow slideInUp">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <swiper :options="swiperOptionSdwan">
            <!-- slides -->
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-1.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-2.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-3.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/sdwan-module8-4.jpg')" /></swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination swiper-sdwan-pagination"  slot="pagination"></div>
            <div class="swiper-button-prev swiper-sdwan-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next swiper-sdwan-button-next" slot="button-next"></div>
          </swiper>
        </el-col>
      </div>
    </div>
    <div class="bgbox-gray bgbox-img">
      <div class="module-title fc-white">
        IPTV智慧桌面系统展示
      </div>
      <div class="project-box project-iptv">
        <el-col :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row :gutter="12">
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.1s">
                <img :src="require('@/assets/images/index-project2-1.jpg')" />
                <p>智慧党建</p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <img :src="require('@/assets/images/index-project2-2.jpg')" />
                <p>智能酒店</p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <img :src="require('@/assets/images/index-project2-3.jpg')" />
                <p>智慧监狱</p>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row :gutter="12">
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                <img :src="require('@/assets/images/index-project2-4.jpg')" />
                <p>智能医院</p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                <img :src="require('@/assets/images/index-project2-5.jpg')" />
                <p>教育场景</p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                <img :src="require('@/assets/images/index-project2-6.jpg')" />
                <p>足浴桑拿</p>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-white">
      <div class="module-title fc-blue">
        公司资质
      </div>
      <div class="project-box wow zoomIn">
        <el-col class="company-certify" :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <swiper :options="swiperOptionCompany">
            <!-- slides -->
            <swiper-slide><img :src="require('@/assets/images/index-company1.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/index-company2.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/index-company3.jpg')" /></swiper-slide>
            <swiper-slide><img :src="require('@/assets/images/index-company4.jpg')" /></swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev swiper-company-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next swiper-company-button-next" slot="button-next"></div>
          </swiper>
        </el-col>
      </div>
    </div>
    <div class="bgbox-gray">
      <div class="module-title fc-blue">
        合作客户
      </div>
      <div class="partner-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <swiper :options="swiperOptionPartner">
            <!-- slides -->
            <swiper-slide v-for="n in 36" :key="n">
              <div class="img-box">
                <img class="wow slideInUp" data-wow-delay="0.1s" :src="require('@/assets/images/index-partner'+n+'.jpg')" />
              </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination swiper-partner-pagination"  slot="pagination"></div>
          </swiper>
        </el-col>
      </div>
    </div>
    <el-dialog :visible.sync="showBigImg" :center="true" :show-close="false" custom-class="dialog-bigimg">
      <img :src="bigImgSrc" />
    </el-dialog>
  </div>
</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    components: {
      swiper,
      swiperSlide
    },
    data() {
      let vm = this
      return {
        showBigImg: false,
        bigImgSrc:null,
        swiperOptionBanner: {
          autoHeight: true,
          slidesPerView: 1,//显示数量
          loop: true,
          // autoplay:{
          //   delay: 8000,
          //   disableOnInteraction: false//点击切换后 停止继续自动播放
          // },
          effect: 'fade',//渐变
          pagination: {
            el: '.swiper-banner-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-banner-button-next',
            prevEl: '.swiper-banner-button-prev',
          }
        },
        swiperOptionCard: {
          slidesPerView: 4,//显示数量
          spaceBetween: 10,
          centeredSlides: false,//居中slide
          loop: false,
          autoplay:false,
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            }
          },
          pagination: {
            el: '.swiper-card-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-card-button-next',
            prevEl: '.swiper-card-button-prev',
          }
        },
        swiperOptionSdwan: {
          autoHeight: true,
          slidesPerView: 1,//显示数量
          loop: true,
          autoplay:{
            delay: 5000,
            disableOnInteraction: false//点击切换后 继续自动播放
          },
          pagination: {
            el: '.swiper-sdwan-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-sdwan-button-next',
            prevEl: '.swiper-sdwan-button-prev',
          }
        },
        swiperOptionCompany: {
          slidesPerView: 4,//显示数量
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          autoplay:{
            delay: 5000,
            disableOnInteraction: false//点击切换后 停止继续自动播放
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 30,
            }
          },
          navigation: {
            nextEl: '.swiper-company-button-next',
            prevEl: '.swiper-company-button-prev',
          },
          on:{
            click:function(){
              if(this.clickedSlide){
                vm.bigImgSrc = this.clickedSlide.getElementsByTagName('img')[0].getAttribute('src');
                vm.showBigImg = true;
                // console.log(this.clickedSlide.getAttribute('data-swiper-slide-index'));
                // console.log(this);
              }
            }
          }
        },
        swiperOptionPartner: {
          slidesPerView: 6,//显示数量
          slidesPerColumn: 3,
          spaceBetween: 0,
          centeredSlides: false,//居中slide
          loop: false,
          autoplay:{
            delay: 1200,
            disableOnInteraction: false//点击切换后 停止继续自动播放
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 0,
            }
          },
          pagination: {
            el: '.swiper-partner-pagination',
            clickable: true,
          }
        },
      }
    },
    mounted(){
      
    },
    methods:{
      
    }
  };
</script>
<style lang="scss">
  // banner swiper
  .carousel-banner {
    .swiper-pagination{
      display: flex;
      align-items: center;
      position: absolute;
      width: auto;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 11px;
      padding: 6px 16px;
    }
    .swiper-pagination-bullet{
      width: 6px !important;
      height: 6px !important;
      background: #fff !important;
      opacity: .8;
    }
    .swiper-pagination-bullet-active{
      background: transparent !important;
      border: 2px solid #fff !important;
    }
  }
  .partner-box{
    .swiper-container{
      width: 100%;
    }
    .swiper-wrapper{
      padding-bottom: 20px;
    }
    .swiper-pagination{
      bottom: 0;
    }
    .swiper-pagination-bullet{
      width: 18px !important;
      border-radius: 0;
    }
  }
  // big img
  .dialog-bigimg{
    box-shadow: none;
    background: transparent;
    margin: 5% auto 0 !important;
    width: fit-content !important;
    height: auto !important;
    overflow: hidden;
    .el-dialog__header{
      display: none;
    }
    .el-dialog__body{
      padding: 0;
      width: fit-content !important;
      height: auto !important;
      img{
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
        display: block;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .carousel-banner {
    width: 100%;
    position: relative;
    .swiper-container {
      height: 100%;
      width: 100%;
    }
    .swiper-slide .banner-img{
      width: 100%;
    }
    .swiper-button-prev,.swiper-button-next{
      outline: none;
      height: 30px;
    }
    .item1 .details-box{
      width: 30%;
      position: absolute;
      right: 18%;
      top: 10%;
      img{
        width: 100%;
        max-width: 570px;
      }
      .btn{
        margin-top: 30px;
        float: right;
      }
    }
    .item2{
      .details-box{
        width: 30%;
        max-width: 510px;
        position: absolute;
        right: 18%;
        top: 28%;
        img{
          width: 100%;
          max-width: 510px;
        }
        .btn{
          margin-top: 10px;
        }
      }
    }
    .item3{
      .details-box{
        width: 30%;
        max-width: 515px;
        position: absolute;
        left: 18%;
        top: 28%;
        img{
          width: 100%;
        }
        .btn{
          margin-top: 10px;
        }
      }
    }
    .item4{
      .details-box{
        width: 30%;
        max-width: 676px;
        position: absolute;
        left: 18%;
        top: 28%;
        text-align: center;
        img{
          width: 100%;
        }
        .btn{
          margin-top: 10px;
        }
      }
    }
  }
  @media screen and (max-width: 767px){
    .carousel-banner {
      .banner-img{
        height: 270px;
        object-fit: cover;
      }
      .item1 .details-box{
        width: 38%;
        position: absolute;
        right: 10%;
        top: 10%;
        img{
          width: 100%;
        }
        .btn{
          margin-top: 10px;
          float: right;
        }
      }
      .item2{
        .banner-img{
          object-position: left;
        }
        .details-box{
          width: 260px;
          position: absolute;
          right: 16%;
          top: 12%;
          padding: 10px;
          box-sizing: border-box;
          background: rgba($color: #000000, $alpha: 0.7);
          border-radius: 6px;
          img{
            width: 100%;
          }
          .btn{
            margin-top: 10px;
          }
        }
      }
      .item3{
        .banner-img{
          object-position: right;
        }
        .details-box{
          width: 260px;
          position: absolute;
          left: 12%;
          top: 12%;
          padding: 10px;
          box-sizing: border-box;
          background: rgba($color: #000000, $alpha: 0.7);
          border-radius: 6px;
        }
      }
      .item4{
        background: #977144;
        .banner-img{
          opacity: 0;
        }
        .details-box{
          width: 300px;
          position: absolute;
          left: 50%;
          top: 12%;
          padding: 10px;
          box-sizing: border-box;
          transform: translateX(-50%);
        }
      }
    }
  }

  .flex-col{
    display: flex;
    align-items: center;
  }
  .bgbox-white{
    padding: 50px 0;
    overflow: hidden;
    background: #fff;
  }
  .bgbox-gray{
    padding: 50px 0;
    overflow: hidden;
    background: #f7f7f7;
  }
  .module-title{
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
    padding-bottom: 14px;
    position: relative;
  }
  .fc-blue{
    color: #0066cc;
  }
  .module-title.fc-blue::after{
    content: "";
    width: 80px;
    height: 4px;
    background: #0066cc;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -40px;
    border-radius: 5px;
  }
  .fc-white{
    color: #fff;
  }
  .module-title.fc-white::after{
    content: "";
    width: 80px;
    height: 4px;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -40px;
    border-radius: 5px;
  }

  .card-show{
    overflow: hidden;
    .item{
      float: left;
      width: 100%;
      margin-right: 12px;
      margin-bottom: 10px;
      background: #fff;
      padding: 20px 10px;
      box-sizing: border-box;
      transition: all 0.3s ease;
      h3{
        font-size: 20px;
        color: #333;
        padding-bottom: 5px;
      }
      h4{
        height: 30px;
        font-size: 13px;
        color: #333;
        font-weight: 400;
        margin-bottom: 20px;
      }
      p{
        height: 60px;
        font-size: 14px;
        color: #666;
        margin: 20px 0;
      }
      .img-box{
        width: 100%;
        height: 170px;
        overflow: hidden;
        img{
          min-height:100%;
          width:100%;
          object-fit: cover;
          transition: all 0.3s ease;
        }
      }
    }
    .item:hover{
      cursor: pointer;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      transform: translate3d(0,-2px,0);
      img{
        transform: scale(1.1);
      }
      .el-button{
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
    .item:last-child{
      margin-right:0; 
    }
    .swiper-button-prev,.swiper-button-next{
      outline: none;
      height: 30px;
    }
  }

  .product-box{
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .product-box img{
    width: 100%;
  }
  .product-box .item-img{
    padding: 0 20px;
    box-sizing: border-box;
  }
  .product-box .conts{
    cursor: pointer;
    padding: 10px;
    transition: all .3s ease-in;
    &:hover{
      transform: translate3d(0,-6px,0);
    }
  }
  .product-box .conts h3{
    font-size: 20px;
    color: #333;
    padding-bottom: 5px;
  }
  .product-box .conts h4{
    font-size: 13px;
    color: #333;
    font-weight: 400;
    margin-bottom: 50px;
  }
  .product-box .conts .article{
    font-size: 16px;
    color: #333;
  }
  .stress-box{
    padding-top: 30px;
    box-sizing: border-box;
  }
  .stress-box h5{
    font-size: 16px;
    color: #333;
    margin-bottom: 30px;
  }
  .stress-box .stress-items{
    overflow: hidden;
  }
  .stress-box .stress-items .item{
    float: left;
    width: 80px;
    height: 80px;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    text-align: center;
    padding-top: 12px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .stress-box .stress-items .item:last-child{
    margin-right: 0;
  }
  .stress-box .stress-items .item p{
    font-size: 14px;
    color: #808080;
  }

  .project-box{
    overflow: hidden;
    width: 100%;
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
  .project-sdwan{
    .swiper-container {
      width: 100%;
    }
    .swiper-slide img{
      width: 100%;
    }
    .swiper-button-prev,.swiper-button-next{
      outline: none;
      height: 30px;
    }
  }

  .bgbox-img{
    background: url("../../assets/images/index-project-bg.jpg") no-repeat;
    background-size: 100% 100%;
  }
  .project-iptv-item {
    margin-bottom: 20px;
  }
  .project-iptv-item img{
    cursor: pointer;
    vertical-align: middle;
    width: 100%;
    transition: all 0.5s ease;
  }
  .project-iptv-item p{
    font-size: 20px;
    color: #fff;
    text-align: center;
    line-height: 30px;
  }

  .company-certify{
    height: auto;
    .swiper-container {
      width: 100%;
      height: 100%;
      &::before{
        content:"";
        width: 12%;
        height: 100%;
        background: linear-gradient(right, rgba(255,255,255,0) , rgba(255,255,255,1));
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9;
      }
      &::after{
        content:"";
        width: 12%;
        height: 100%;
        background: linear-gradient(left, rgba(255,255,255,0) , rgba(255,255,255,1));
        position: absolute;
        right: 0;
        top: 0;
        z-index: 9;
      }
    }
    .swiper-slide{
      height: 100%;
      text-align: center;
    }
    .swiper-slide img{
      max-width: 100%;
      max-height: 400px;
      border: 1px solid #eee;
      box-sizing: border-box;
      cursor: pointer;
    }
    .swiper-button-prev,.swiper-button-next{
      outline: none;
      height: 30px;
    }
  }

  .partner-box{
    overflow: hidden;
    width: 100%;
    padding: 40px 10px 0;
    box-sizing: border-box;
    .img-box{
      padding: 5px;
      box-sizing: border-box;
      img{
        width: 100%;
        vertical-align: middle;
        border: 1px solid #eee;
        box-sizing: border-box;
        transition: all 0.5s ease;
        &:hover{
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  // 移动端css
  @media screen and (max-width: 767px){
    .product-box .conts{
      padding: 0;
      &:hover{
        background-size: 0;
        box-shadow: none;
      }
    }
    .product-box .conts h4{
      margin-bottom: 20px;
    }
  }

  // 991
  @media screen and (max-width: 991px) {
    .flex-row{
      display: block;
    }
  }
</style>
